import React from "react"

import {FormattedMessage} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import theme from "@irati/ui/src/global/theme"
import {Hr} from "@irati/ui/src/Layout"
import {H5} from "@irati/ui/src/Typography"

type Props = {
  headerId: string
}

const OrderInfoCol: React.FC<Props> = ({headerId, children}) => (
  <Flex flex="1 1 300px" direction="column">
    <Hr margin={[theme.spacing.two, 0]} />
    <H5 marginBottom={theme.spacing.two}>
      <FormattedMessage id={headerId} />
    </H5>
    {children}
  </Flex>
)

export default OrderInfoCol
